import { useQuery, UseQueryOptions } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchSelect } from '../../interfaces';

export const useBranches = (includeDeleted?: boolean, options?: UseQueryOptions<IBranchSelect[], Error, IBranchSelect[], ['branches-select', boolean | undefined]>) => {
  return useQuery<IBranchSelect[], Error, IBranchSelect[], ['branches-select', boolean | undefined]>(
    ['branches-select', includeDeleted],
    async ({ queryKey }) => {
      const [, deleted] = queryKey;
      const result = await BranchesService.getSelect(deleted);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000, ...options },
  );
};
